<template>
  <input
    id="onlineEditor"
    ref="onlineEditor"
    type="hidden"
    name="online_editor"
  />
  <input
    id="steckdosenEditor"
    ref="steckdosenEditor"
    type="hidden"
    name="steckdosen_editor"
  />
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useImageEditorStore } from "@/stores/modules/imageEditor";

import { mapState, mapActions } from "pinia";

import * as R from "ramda";

export default {
  computed: {
    ...mapState(useImageEditorStore, {
      POIEVariables: "getPOIEVariables"
    })
  },
  methods: {
    ...mapActions(useChangeOptionsStore, ["registerAddToCartCallback"]),
    getPdfData: function () {
      var result = {
        images: [],
        width: 0,
        height: 0,
        color_device: "rgb",
        color: "#ff00ff",
        path: lfpGlobalStore.originalPath,
        uploadedFile: lfpGlobalStore.uploadedFile,
        split: {
          enable: 0
        }
      };
      var pdfUnit = lfpGlobalStore.pdfUnit;
      var margin = lfpGlobalStore.getMarginsWithThickness;
      var format = lfpGlobalStore.getFormat;
      var fullFormat = lfpGlobalStore.getFullFormatDim;
      var originalImageSize = lfpGlobalStore.originalImageSize;
      result["width"] = fullFormat.width * this.POIEVariables.cmToPt;
      result["height"] = fullFormat.height * this.POIEVariables.cmToPt;
      result["image_src"] = lfpGlobalStore.image.resized.src;
      var image = {
        filename: "",
        path: "",
        cropX: 0,
        cropY: 0,
        cropX1: 0,
        cropY1: 0,
        cropH: 0,
        cropW: 0,
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        type: "normal",
        circle_distance: 0,
        rotate_angle: 0
      };
      image.uuid = lfpGlobalStore.image.original.imageId;
      result["files"] = [];
      result["files"].push(image.uuid);
      if (this.POIEVariables.splitOiePdf) {
        var splitMargins = lfpGlobalStore.getSplitMargins;
        result.split = {
          enable: 1,
          margin: {
            left: splitMargins.left * this.POIEVariables.cmToPt,
            right: splitMargins.right * this.POIEVariables.cmToPt
          },
          lines: lfpGlobalStore.split
        };
      }
      if (margin.type < 0) {
        //enlarged
        image.x = 0;
        image.y = 0;
        image.width = result["width"]; //block_width
        image.height = result["height"]; //block_height
        if (lfpGlobalStore.isRounded) {
          image.type = "circle";
        }
        image = this.getRotateDimensionsEnlarged(image);
        result["images"] = this.pushImage(result["images"], image);
        result["trimbox"] = {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        };
        result["outlets"] = [];
        result["cutouts"] = [];
        result["block_images"] = {};
        result["corners"] = {};
      } else {
        //mirrored, white, monochromatic
        image.x = margin.left * this.POIEVariables.cmToPt;
        image.y = margin.top * this.POIEVariables.cmToPt;
        image.width = format.width * this.POIEVariables.cmToPt; //block_width
        image.height = format.height * this.POIEVariables.cmToPt; //block_height
        switch (format.type) {
          case 1:
            image.cropX = 0;
            image.cropX1 = 0;
            break;
          case 2:
            image.cropY = 0;
            image.cropY1 = 0;
            break;
        }
        switch (margin.subtype) {
          case 1: //mirrored
            result["color"] = "#fff";
            image = this.getRotateDimensionsWithMargins(image);
            var image_top = jQuery.extend(true, {}, image);
            var image_right = jQuery.extend(true, {}, image);
            var image_bottom = jQuery.extend(true, {}, image);
            var image_left = jQuery.extend(true, {}, image);
            image_top = this.getRotateDimesionTop(image_top, margin);
            image_right = this.getRotateDimesionRight(image_right, margin);
            image_bottom = this.getRotateDimesionBottom(image_bottom, margin);
            image_left = this.getRotateDimesionLeft(image_left, margin);
            break;
          case 2: //white
            if (lfpGlobalStore.isRounded) {
              image.type = "circle";
            }
            result["color"] = "#fff";
            image = this.getRotateDimensionsWithMargins(image);
            break;
          case 3: //monochromatic
            result["color"] = margin.color;
            if (lfpGlobalStore.isRounded) {
              image.type = "circle";
            }
            image = this.getRotateDimensionsWithMargins(image);
            break;
        }
        result["images"] = this.pushImage(result["images"], image);
        if (margin.subtype == 1) {
          result["images"] = this.pushImage(result["images"], image_top);
          result["images"] = this.pushImage(result["images"], image_right);
          result["images"] = this.pushImage(result["images"], image_bottom);
          result["images"] = this.pushImage(result["images"], image_left);
        }
        result["outlets"] = [];
        result["cutouts"] = [];
        result["block_images"] = {};
        result["corners"] = {};
        var margins = lfpGlobalStore.margin;
        result["trimbox"] = {
          top: margins.top * this.POIEVariables.cmToPt,
          left: margins.left * this.POIEVariables.cmToPt,
          bottom: margins.bottom * this.POIEVariables.cmToPt,
          right: margins.left * this.POIEVariables.cmToPt
        };
      }
      if (lfpGlobalStore.steckdosen.dosens.length) {
        R.forEach(dosen => {
          var outlet = {
            left:
              dosen.left * this.POIEVariables.cmToPt -
              dosen.offsetX * this.POIEVariables.cmToPt +
              result["trimbox"].left,
            top:
              dosen.bottom * this.POIEVariables.cmToPt -
              dosen.offsetY * this.POIEVariables.cmToPt +
              result["trimbox"].top,
            width: dosen.width * this.POIEVariables.cmToPt,
            height: dosen.height * this.POIEVariables.cmToPt
          };
          result["outlets"].push(outlet);
        }, lfpGlobalStore.steckdosen.dosens);
      }
      if (lfpGlobalStore.cutouts.cutouts.length) {
        R.forEach(cutout => {
          var item = {
            left:
              cutout.left * this.POIEVariables.cmToPt -
              cutout.offsetX * this.POIEVariables.cmToPt +
              result["trimbox"].left,
            top:
              cutout.bottom * this.POIEVariables.cmToPt -
              cutout.offsetY * this.POIEVariables.cmToPt +
              result["trimbox"].top,
            width: cutout.width * this.POIEVariables.cmToPt,
            height: cutout.height * this.POIEVariables.cmToPt,
            type: cutout.itemType
          };
          result["cutouts"].push(item);
        }, lfpGlobalStore.cutouts.cutouts);
      }
      if (lfpGlobalStore.object.objects.length) {
        R.forEachObjIndexed((object, key) => {
          if (object["type"] === "image" && object["subtype"] === "cropimage") {
            var rotateAngle = ((object.angle * 180) / Math.PI) % 360;
            var item = {
              left:
                object.left * this.POIEVariables.cmToPt -
                object.offsetX * this.POIEVariables.cmToPt +
                result["trimbox"].left,
              top:
                object.bottom * this.POIEVariables.cmToPt -
                object.offsetY * this.POIEVariables.cmToPt +
                result["trimbox"].top,
              width: object.width * this.POIEVariables.cmToPt,
              height: object.height * this.POIEVariables.cmToPt,
              ratioWidth: object.ratioWidth,
              ratioHeight: object.ratioHeight,
              cropX: object.cropData.x * object.ratioWidth,
              cropY:
                (object.canvasData.naturalHeight -
                  (object.cropData.height + object.cropData.y)) *
                object.ratioHeight,
              cropW: object.cropData.width * object.ratioWidth,
              cropH: object.cropData.height * object.ratioHeight,
              scaleX: object.cropData.scaleX,
              rotateAngle: -1 * rotateAngle,
              isPdf: object.isPdf,
              uuid: object.uuid
            };
            if (object.cropData.scaleX == -1) {
              item.cropX =
                (object.canvasData.naturalWidth -
                  (object.cropData.width + object.cropData.x)) *
                object.ratioWidth;
            }
            if (rotateAngle != 0) {
              var tetha = -1 * object.angle;
              var topleft = {
                x: (item["width"] * -1) / 2,
                y: (item["height"] * -1) / 2
              };
              var topLeftD = {
                x: topleft.x * Math.cos(tetha) - topleft.y * Math.sin(tetha),
                y: topleft.x * Math.sin(tetha) + topleft.y * Math.cos(tetha)
              };
              var deviation = {
                x: topleft.x - topLeftD.x,
                y: topLeftD.y - topleft.y
              };
              item.left = item.left - deviation.x;
              item.top = item.top + deviation.y;
            }
            result["block_images"][key] = item;
            result["files"].push(item.uuid);
          }
        }, lfpGlobalStore.object.objects);
        var index = 0;
        R.forEachObjIndexed((item, key) => {
          var corner = {
            x: item.x * this.POIEVariables.cmToPt,
            y: item.y * this.POIEVariables.cmToPt,
            type: item.type,
            isActive: item.isActive,
            subtype: item.subItems[item.subItemIndex].type
          };
          result["corners"][key] = corner;
        }, lfpGlobalStore.corners.corners);
      }
      result.white_margin = lfpGlobalStore.getEnableWhiteMargin;
      result.width_margin = margin.whitetop * this.POIEVariables.cmToPt;
      return result;
    },
    getRotateDimensionsEnlarged: function (image) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      var editorCanvasByFormat = lfpGlobalStore.editor.dim.canvasDimByFormat;
      var canvasUnit = lfpGlobalStore.editor.dim.canvasDimByFormat.unit;
      var canvasFormatDimByFormat = lfpGlobalStore.canvasFormatDimByFormat;
      var zoom = lfpGlobalStore.editor.zoom / 100;
      var originalImageSize = lfpGlobalStore.originalImageSize;
      var width = canvasFormatDimByFormat.width_fix * canvasUnit;
      var height = canvasFormatDimByFormat.height_fix * canvasUnit;
      var cLeft = canvasFormatDimByFormat.left * canvasUnit;
      var cTop = canvasFormatDimByFormat.top * canvasUnit;
      var cBottom = canvasFormatDimByFormat.bottom * canvasUnit;
      var cRight = canvasFormatDimByFormat.right * canvasUnit;
      var zoomW = width / zoom;
      var zoomH = height / zoom;
      var centerW = editorCanvasByFormat.width_fix / 2;
      var centerH = editorCanvasByFormat.height_fix / 2;
      var focalPoint = lfpGlobalStore.editor.focalPoint;
      var left = ((focalPoint.x * zoom - centerW) * canvasUnit + cLeft) / zoom;
      var top = ((focalPoint.y * zoom - centerH) * canvasUnit + cTop) / zoom;
      var right =
        ((focalPoint.x * zoom - centerW) * canvasUnit + cRight) / zoom;
      var bottom =
        ((focalPoint.y * zoom - centerH) * canvasUnit + cBottom) / zoom;
      var rLeft =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cLeft) /
        zoom;
      var rTop =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cTop) /
        zoom;
      var rRight =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cRight) /
        zoom;
      var rBottom =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cBottom) /
        zoom;
      var dimmensions = {
        left: left,
        top: top,
        bottom: bottom,
        right: right,
        rLeft: rLeft,
        rTop: rTop,
        rBottom: rBottom,
        rRight: rRight,
        width: zoomW,
        height: zoomH
      };
      switch (image.rotate_angle) {
        case 90:
          image.cropX = dimmensions.top;
          image.cropY = dimmensions.rRight;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        case 180:
          image.cropX = dimmensions.rRight;
          image.cropY = dimmensions.rBottom;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
        case 270:
          image.cropX = dimmensions.rBottom;
          image.cropY = dimmensions.left;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        default:
          image.cropX = dimmensions.left;
          image.cropY = dimmensions.top;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
      }
      var imageUnit = lfpGlobalStore.editor.dim.imageDimByFormat.unit;
      if (lfpGlobalStore.getEnableWhiteMargin) {
        if (image.cropX < 0) {
          var unit = imageUnit / canvasUnit;
          image.x =
            -1 *
            ((((image.cropX / canvasUnit) * zoom) / unit) *
              this.POIEVariables.cmToPt);
          image.cropW = image.cropW + image.cropX;
          image.cropX = 0;
          image.width = image.width - image.x;
        }
        var unit = imageUnit / canvasUnit;
        if (image.cropY < 0) {
          image.y =
            -1 *
            ((((image.cropY / canvasUnit) * zoom) / unit) *
              this.POIEVariables.cmToPt);
          image.cropH = image.cropH + image.cropY;
          image.cropY = 0;
          image.height = image.height - image.y;
        }
        var diffWidth = image.cropW + image.cropX;
        var margin = lfpGlobalStore.getMargin;
        var fullFormat = lfpGlobalStore.getFullFormatDim;
        if (dimmensions.rRight < 0) {
          image.cropW = image.cropW + dimmensions.rRight * zoom;
          image.height =
            image.width +
            (((dimmensions.rRight / canvasUnit) * zoom) / unit) *
              this.POIEVariables.cmToPt;
          //  image.cropY = image.cropY - diffHeight;
        }
        if (
          image.width <
          (fullFormat.width - margin.whiteright) * this.POIEVariables.cmToPt
        ) {
          image.width =
            (fullFormat.width - margin.whiteright) * this.POIEVariables.cmToPt;
        }
        var diffHeight = image.cropH;
        if (dimmensions.rBottom < 0) {
          image.cropH = image.cropH + dimmensions.rBottom * zoom;
          image.height =
            image.height +
            (((dimmensions.rBottom / canvasUnit) * zoom) / unit) *
              this.POIEVariables.cmToPt;
          //  image.cropY = image.cropY - diffHeight;
        }
        if (
          image.height <
          (fullFormat.height - margin.whitebottom) * this.POIEVariables.cmToPt
        ) {
          image.height =
            (fullFormat.height - margin.whitebottom) *
            this.POIEVariables.cmToPt;
        }
      }
      return image;
    },
    getRotateDimensionsWithMargins: function (image) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      var pdfUnit = lfpGlobalStore.pdfUnit;
      var canvasUnit = lfpGlobalStore.editor.dim.canvasDimByFormat.unit;
      var margin = lfpGlobalStore.getMarginsWithThickness;
      var canvasFormatDimByFormat = lfpGlobalStore.canvasFormatDimByFormat;
      var editorCanvasByFormat = lfpGlobalStore.editor.dim.canvasDimByFormat;
      var zoom = lfpGlobalStore.editor.zoom / 100;
      var originalImageSize = lfpGlobalStore.originalImageSize;
      var cLeft = canvasFormatDimByFormat.left * canvasUnit;
      var cTop = canvasFormatDimByFormat.top * canvasUnit;
      var cBottom = canvasFormatDimByFormat.bottom * canvasUnit;
      var cRight = canvasFormatDimByFormat.right * canvasUnit;
      var width =
        canvasFormatDimByFormat.width_fix * canvasUnit -
        margin.left * pdfUnit -
        margin.right * pdfUnit;
      var height =
        canvasFormatDimByFormat.height_fix * canvasUnit -
        margin.top * pdfUnit -
        margin.bottom * pdfUnit;
      var zoomW = width / zoom;
      var zoomH = height / zoom;

      var centerW = editorCanvasByFormat.width_fix / 2;
      var centerH = editorCanvasByFormat.height_fix / 2;
      var focalPoint = lfpGlobalStore.editor.focalPoint;
      var left = ((focalPoint.x * zoom - centerW) * canvasUnit + cLeft) / zoom;
      var top = ((focalPoint.y * zoom - centerH) * canvasUnit + cTop) / zoom;
      var right =
        ((focalPoint.x * zoom - centerW) * canvasUnit + cRight) / zoom;
      var bottom =
        ((focalPoint.y * zoom - centerH) * canvasUnit + cBottom) / zoom;
      left = left + (margin.left * pdfUnit) / zoom;
      top = top + (margin.top * pdfUnit) / zoom;
      var rLeft =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cLeft) /
        zoom;
      var rTop =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cTop) /
        zoom;
      var rRight =
        (((centerW - focalPoint.x + centerW) * zoom - centerW) * canvasUnit +
          cRight) /
        zoom;
      var rBottom =
        (((centerH - focalPoint.y + centerH) * zoom - centerH) * canvasUnit +
          cBottom) /
        zoom;
      rRight =
        rRight -
        margin.left * pdfUnit -
        margin.right * pdfUnit +
        (margin.right * pdfUnit) / zoom;
      rBottom =
        rBottom -
        margin.bottom * pdfUnit -
        margin.top * pdfUnit +
        (margin.bottom * pdfUnit) / zoom;

      if (left < 0) {
        left = 0;
      }
      var dimmensions = {
        left: left,
        top: top,
        bottom: bottom,
        right: right,
        rLeft: rLeft,
        rTop: rTop,
        rRight: rRight,
        rBottom: rBottom,
        width: zoomW,
        height: zoomH
      };
      image = this.getRotate(image, dimmensions);
      return image;
    },
    getRotateDimesionTop: function (image, margin) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      image.y = 0;
      image.height = margin.top * this.POIEVariables.cmToPt;
      switch (image.rotate_angle) {
        case 90:
          image = this.getRotateLeft(image, margin.top);
          break;
        case 180:
          image = this.getRotateBottom(image, margin.top);
          break;
        case 270:
          image = this.getRotateRight(image, margin.top);
          break;
        default:
          image = this.getRotateTop(image, margin.top);
          break;
      }
      return image;
    },
    getRotateDimesionRight: function (image, margin) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      image.x = image.x + image.width;
      image.width = margin.right * this.POIEVariables.cmToPt;
      switch (image.rotate_angle) {
        case 90:
          image = this.getRotateTop(image, margin.right);
          break;
        case 180:
          image = this.getRotateLeft(image, margin.right);
          break;
        case 270:
          image = this.getRotateBottom(image, margin.right);
          break;
        default:
          image = this.getRotateRight(image, margin.right);
          break;
      }
      return image;
    },
    getRotateDimesionBottom: function (image, margin) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      image.y = image.y + image.height;
      image.height = margin.bottom * this.POIEVariables.cmToPt;
      switch (image.rotate_angle) {
        case 90:
          image = this.getRotateRight(image, margin.bottom);
          break;
        case 180:
          image = this.getRotateTop(image, margin.bottom);
          break;
        case 270:
          this.getRotateLeft(image, margin.bottom);
          break;
        default:
          this.getRotateBottom(image, margin.bottom);
          break;
      }
      return image;
    },
    getRotateDimesionLeft: function (image, margin) {
      image.rotate_angle = lfpGlobalStore.getRotateAngle;
      image.x = 0;
      image.width = margin.left * this.POIEVariables.cmToPt;
      switch (image.rotate_angle) {
        case 90:
          image = this.getRotateBottom(image, margin.left);
          break;
        case 180:
          image = this.getRotateRight(image, margin.left);
          break;
        case 270:
          this.getRotateTop(image, margin.left);
          break;
        default:
          this.getRotateLeft(image, margin.left);
          break;
      }
      return image;
    },
    getRotateTop: function (image, margin) {
      var pdfUnit = lfpGlobalStore.pdfUnit;
      image.type = "top";
      image.cropH = margin * pdfUnit;
      return image;
    },
    getRotateRight: function (image, margin) {
      var pdfUnit = lfpGlobalStore.pdfUnit;
      image.type = "right";
      image.cropX = image.cropX + image.cropW - margin * pdfUnit;
      image.cropW = margin * pdfUnit;
      return image;
    },
    getRotateBottom: function (image, margin) {
      var pdfUnit = lfpGlobalStore.pdfUnit;
      image.cropY = image.cropY + image.cropH - margin * pdfUnit;
      image.cropH = margin * pdfUnit;
      image.type = "bottom";
      return image;
    },
    getRotateLeft: function (image, margin) {
      var pdfUnit = lfpGlobalStore.pdfUnit;
      image.cropW = margin * pdfUnit;
      image.type = "left";
      return image;
    },
    getRotate: function (image, dimmensions) {
      switch (image.rotate_angle) {
        case 90:
          image.cropX = dimmensions.top;
          image.cropY = dimmensions.rRight;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        case 180:
          image.cropX = dimmensions.rRight;
          image.cropY = dimmensions.rBottom;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
        case 270:
          image.cropX = dimmensions.rBottom;
          image.cropY = dimmensions.left;
          image.cropW = dimmensions.height;
          image.cropH = dimmensions.width;
          break;
        default:
          image.cropX = dimmensions.left;
          image.cropY = dimmensions.top;
          image.cropW = dimmensions.width;
          image.cropH = dimmensions.height;
          break;
      }
      return image;
      /*
				  switch (image.rotate_angle) {
					  case 90:
						  image.cropX = dimmensions.top;
						  image.cropY = dimmensions.right;
						  image.cropW = dimmensions.height;
						  image.cropH = dimmensions.width;
						  break;
					  case 180:
						  image.cropX = dimmensions.right;
						  image.cropY = dimmensions.bottom;
						  image.cropW = dimmensions.width;
						  image.cropH = dimmensions.height;
						  break;
					  case 270:
						  image.cropX = dimmensions.bottom;
						  image.cropY = dimmensions.left;
						  image.cropW = dimmensions.height;
						  image.cropH = dimmensions.width;
						  break;
					  default:
						  image.cropX = dimmensions.left;
						  image.cropY = dimmensions.top;
						  image.cropW = dimmensions.width;
						  image.cropH = dimmensions.height;
						  break;
				  }
				  return image;*/
    },
    generatePdf: function () {
      jQuery
        .ajax({
          type: "POST",
          url: this.POIEVariables.Urls.generatePdf,
          dataType: "JSON",
          data: {
            filename: "oie_result.pdf",
            config: this.getPdfData()
          }
        })
        .done(response => {
          window.open(response.link);
          console.log(response);
        })
        .fail(response => {
          console.log(response);
        });
    },
    generateSteckdosen: function () {
      var steckdosen = [];
      jQuery.each(lfpGlobalStore.steckdosen.dosens, (index, dosen) => {
        var steckdose = {
          type: dosen.type,
          posx: dosen.left,
          posy: dosen.bottom
        };
        steckdosen.push(steckdose);
      });
      return steckdosen;
    },
    pushImage: function (result, image) {
      var add = true;
      try {
        if (typeof image != "object") throw false;
        if (!image.hasOwnProperty("cropH") || !image.hasOwnProperty("cropW"))
          throw false;
        var width = parseFloat(image.cropW);
        var height = parseFloat(image.cropH);
        if (width == 0 || height == 0) throw false;
        if (isNaN(width) || isNaN(height)) throw false;
      } catch (err) {
        add = false;
      }
      if (add) result.push(image);
      return result;
    }
  },
  mounted: function () {
    this.registerAddToCartCallback(() => {
      var pdf_data = this.getPdfData();
      var steckdoses = this.generateSteckdosen();

      jQuery(this.$refs.onlineEditor).val(JSON.stringify(pdf_data));
      jQuery(this.$refs.steckdosenEditor).val(JSON.stringify(steckdoses));
      return {
        pdf_data: pdf_data,
        steckdosen: steckdoses
      };
    });
  }
};
</script>
